// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qV1H","newExpiryDate":"styles_newExpiryDate__dIAdj","footer":"styles_footer__3mt0x"};